import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title: "Proactive business \nnotification for effective \nactions",
  subtitle: "Business Operations Demo",
  text: '<span style="font-weight:bold">Customer Delight</span> — proactive\ncommunications in the event of a milestone\naction being achieved.',
  label: { iconPath: "start.png", text: "Notification Management" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_108"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_106"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 4_R1.mp4",
  pageNumber: "ILO_107",
};

export default DATA_BO_DEMO_ILO1;
